import React from 'react'
import WarehousesApp from '../warehouses/WarehousesApp'
import SectionsApp from '../sections/SectionsApp'
import LocationsApp from '../locations/LocationsApp'
import Grid from '@mui/material/Grid2';
import DynamicSelectItemField from '../../components/Fields/DynamicSelectItemField';
import DynamicModelSelect from '../../components/Fields/DynamicModelSelect';
import UsersApp from '../user/UsersApp';

interface IRequestDesignationProps {
    actionType: string,
    designationType: string,
    warehouseId: number | null,
    sectionId: number | null,
    locationId: number | null,
    userId: number | null,
    updateWarehouseId: (id: number) => void,
    updateSectionId: (id: number) => void,
    updateLocationId: (id: number) => void,
    updateUserId: (id: number) => void,
    disableSelectUserId?: boolean,
}

export default function RequestDesignation(props: IRequestDesignationProps) {

    const { 
        actionType,
        designationType,
        warehouseId,
        sectionId,
        locationId,
        userId,
        updateWarehouseId,
        updateSectionId,
        updateLocationId,
        updateUserId,
        disableSelectUserId,
    } = props

    const warehousesApp = new WarehousesApp()
    const sectionsApp = new SectionsApp()
    const locationsApp = new LocationsApp()
    const usersApp = new UsersApp()

    switch (designationType){

        case "warehouse":
            return(
                <div>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 6 }}>
                            <DynamicModelSelect 
                                id="designation_warehouse"
                                type="DynamicModelSelect"
                                xs={12}
                                handleOnChange={(id: string, value: any) => {
                                    if (!value){
                                        updateWarehouseId(value)
                                        updateSectionId(0)
                                    }else{
                                        updateWarehouseId(value)
                                    }
                                }}
                                data={{ name: "designation_warehouse", value: warehouseId }}
                                fullWidth
                                appClass={warehousesApp}
                                selectLabel="Select Warehouse"
                                label="Warehouse"
                                gridColumns={warehousesApp.gridDataColumns}
                            />
                        </Grid>
                        <Grid size={{ xs: 6 }}>
                            <DynamicModelSelect 
                                id="designation_section"
                                type="DynamicModelSelect"
                                xs={12}
                                handleOnChange={(id: string, value: any) => updateSectionId(value)}
                                data={{ name: "designation_section", value: sectionId }}
                                fullWidth
                                appClass={sectionsApp}
                                selectLabel="Select Section"
                                label="Section"
                                gridColumns={sectionsApp.gridDataColumns}
                                updateSearchParamsBeforeLoadItems={(params) => {
                                    return [
                                        ...params,
                                        {
                                            name: "warehouse_id",
                                            value: warehouseId
                                        }
                                    ]
                                }}
                                disabled={warehouseId ? false : true}
                            />
                        </Grid>
                    </Grid>
                </div>
            )

        case "location":
            return(
                <DynamicModelSelect 
                    id="designation_location"
                    type="DynamicModelSelect"
                    xs={12}
                    handleOnChange={(id: string, value: any) => updateLocationId(value)}
                    data={{ name: "designation_location", value: locationId }}
                    fullWidth
                    appClass={locationsApp}
                    selectLabel="Select Location"
                    label="Location"
                    gridColumns={locationsApp.gridDataColumns}
                />
            )

        case "user":
            return(
                <DynamicModelSelect 
                    id="designation_user"
                    type="DynamicModelSelect"
                    xs={12}
                    handleOnChange={(id: string, value: any) => updateUserId(value)}
                    data={{ name: "designation_user", value: userId }}
                    fullWidth
                    appClass={usersApp}
                    selectLabel="Select User"
                    label="User"
                    gridColumns={usersApp.gridDataColumns}
                    disabled={disableSelectUserId}
                />
            )

        default:
            return <></>
    }

}